import { ScheduledTournamentConfirmationScreen } from '@/screens/scheduled-tournament-confirmation'

export default function () {
  return <ScheduledTournamentConfirmationScreen />
}
